const CACHE_NAME = "menu-zyka-continuity-v1";
const CONTINUITY_ENDPOINT = /(DisplayMenu|MenuList|Categories|FoodItems|Tax|RestaurantLoginConfig|TakeawaySettings)/i;

export const isContinuityRequest = (url, method = "GET") =>
  String(method).toUpperCase() === "GET" && CONTINUITY_ENDPOINT.test(url);

export const rememberContinuityResponse = async (url, response) => {
  if (!response?.ok || !window.caches || !isContinuityRequest(url)) return response;
  const clone = response.clone();
  const headers = new Headers(clone.headers);
  headers.set("X-Menu-Zyka-Cached-At", new Date().toISOString());
  const cached = new Response(await clone.blob(), { status: clone.status, statusText: clone.statusText, headers });
  const cache = await caches.open(CACHE_NAME);
  await cache.put(url, cached);
  return response;
};

export const getContinuityResponse = async url => {
  if (!window.caches || !isContinuityRequest(url)) return null;
  const cache = await caches.open(CACHE_NAME);
  const response = await cache.match(url);
  if (!response) return null;
  const headers = new Headers(response.headers);
  headers.set("X-Offline-Cache", "true");
  return new Response(await response.blob(), { status: response.status, statusText: response.statusText, headers });
};
